// extracted by mini-css-extract-plugin
export default {"qr":"QRCode_qr__cU844"};